import { Select, ISelect } from "./";
import { getPositions } from "../../../apis/public.api";
import { useEffect, useState } from "react";
import { textChooser } from "../../../util/textChooser";
import { formatValuesForSelect } from "../../../helpers/utilities";

interface PositionsProps extends ISelect {}

export const Positions = (props: PositionsProps) => {

    const [positions, setPositions] = useState([]);

    useEffect(() => {
        getPositions().then((positionsData) => {
            formatValuesForSelect(setPositions , positionsData)
        })
    },[])

    return(
        <Select 
            {...props} 
            label={props?.label ?? textChooser("txt103")}
            values={positions} 
            currentValue={props.currentValue} 
        />
    )
}